import AccountKeyIcon from './AccountKeyIcon'

export default AccountKeyIcon
